import { render, staticRenderFns } from "./ArchiveFilter.vue?vue&type=template&id=0b576394&scoped=true&"
import script from "./ArchiveFilter.vue?vue&type=script&lang=js&"
export * from "./ArchiveFilter.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveFilter.vue?vue&type=style&index=0&id=0b576394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b576394",
  null
  
)

export default component.exports